import React from 'react';
import aboutLogo from "../../images/about/logo.png";
import vector from "../../images/about/vector.png";
import email from "../../images/about/email.png";
import message from "../../images/about/message.png";
import "./Modal.css";

const Modal = ({ onClose }) => {
    return (
        <div className="about-modal-overlay">
            <div className="about-modal">
                <div className='row m-0'>
                    <div className='col-lg-6 boxOne'>
                        <img src={aboutLogo} className='logo' alt="about" />
                    </div>
                    <div className='col-lg-6 boxTwo'>
                        <button onClick={onClose} className='closeBtn'>x</button>
                        <h2>Get a Quote</h2>
                        <p className='text'>Fill out the form below with your details to start conversation with our expert</p>
                        <form className='py-4'>
                            <div className="input-group flex-nowrap">
                                <span className="input-group-text" id="addon-wrapping">
                                    <img src={vector} alt="" />
                                </span>
                                <input type="text" className="form-control" placeholder="Username" aria-label="Username" aria-describedby="addon-wrapping" />
                            </div>
                            <div className="input-group flex-nowrap">
                                <span className="input-group-text" id="addon-wrapping">
                                    <img src={email} alt="" />
                                </span>
                                <input type="mail" className="form-control" placeholder="Email" aria-label="Username" aria-describedby="addon-wrapping" />
                            </div>
                            <div className="input-group flex-nowrap">
                                <span className="input-group-text" id="addon-wrapping">
                                    <img src={vector} alt="" />
                                </span>
                                <input type="text" className="form-control" placeholder="Phone" aria-label="Username" aria-describedby="addon-wrapping" />
                            </div>
                            <div className="input-group flex-nowrap">
                                <span className="input-group-text" id="addon-wrapping">
                                    <img src={message} alt="" />
                                </span>
                                <textarea className="form-control" placeholder="Message" aria-label="Username" aria-describedby="addon-wrapping"></textarea>
                            </div>
                            <button className='modalBtn'>Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Modal;
